// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__IHuA5","noBorder":"Separator_noBorder__Vux8Z","noMargin":"Separator_noMargin__nrvAx"};